import React, { useState } from "react";
// import "./footer.scss";
import {
  APP_STORE_IC,
  DOWN_ARROW_IC,
  facebook,
  FACEBOOK_LINK,
  facebook_primary,
  instagram,
  // FB_IC,
  INSTAGRAM_IC,
  INSTAGRAM_LINK,
  instagram_primary,
  linkedin_icon,
  linkedin_icon_primary,
  LINKEDIN_LINK,
  PLAY_STORE_IC,
  plushvie_logo,
  plushvie_logo_gold,
  PLUSHVIE_LOGO_WHITE,
  RightArrow,
  twitter,
  youtube,
  // X_IC,
  // YOUTUBE_IC,
} from "../../assets";
import { Link, useNavigate } from "react-router-dom";
import INPUT from "../Master/INPUT";
import {
  useGetAppDownloadDataQuery,
  useSubscribeMutation,
} from "../../redux/slices/homeSlice";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import BTN from "../Master/BTN";
import GetInTouch from "../home/DagaHome/GetInTouch";

export default function Footer(props) {
  const [isActive, setIsActive] = useState("");
  const navigate = useNavigate();

  const [subscribe] = useSubscribeMutation();

  const {
    data: appDownloadData,
    isSuccess: appDownloadDataIsSuccess,
    isLoading: appDownloadDataIsLoading,
    isError: appDownloadDataIsError,
    error: appDownloadDataError,
  } = useGetAppDownloadDataQuery();

  const subscribeFormik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: async function (values) {
      subscribe({
        body: {
          email: values?.email,
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res?.data) {
          subscribeFormik?.resetForm();
          toast.success(res?.data.message);
        } else {
          toast.error(`${res?.error?.data?.message}`);
        }
      });
    },
    validate: (values) => {
      let errors = {};
      if (!values?.email) {
        errors.email = "Email id is Required!";
      } else if (!isValidEmail(values?.email)) {
        errors.email = "Email is not valid!";
      }
      return errors;
    },
  });

  return (
    <div className="Footer_Container">
      <DagaFooter />
    </div>
  );
}
const year = new Date().getFullYear();
const DagaFooter = () => {
  const [infoOpen, setInfoOpen] = useState(false);
  const [careOpen, setCareOpen] = useState(false);

  const toggleInfoOpen = () => {
    setInfoOpen(!infoOpen);
    if (!infoOpen) {
      setCareOpen(false);
    }
  };

  const toggleCareOpen = () => {
    setCareOpen(!careOpen);
    if (!careOpen) {
      setInfoOpen(false);
    }
  };

  const [subscribe] = useSubscribeMutation();
  const footerformik = useFormik({
    initialValues: {
      email: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.email) {
        errors.email = "Required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
      ) {
        errors.email = "Invalid email address";
      }
      return errors;
    },
    onSubmit: async function (values) {
      subscribe({
        body: {
          email: values?.email,
        },
        user: localStorage.getItem("user"),
      }).then((res) => {
        if (res?.data) {
          footerformik?.resetForm();
          toast.success(res?.data.message);
        } else {
          toast.error(`${res?.error?.data?.message}`);
        }
      });
    },
  });

  return (
    <div className="">
      <GetInTouch />
      <div className="flex flex-col sm:flex-row justify-between pt-10 lg:pt-16 pb-6 lg:pb-16 px-8 lg:px-16 xl:px-24">
        <div className="order-2 sm:order-1 flex flex-col gap-1 lg:gap-3">
          <div
            className="flex justify-between items-center"
            onClick={toggleInfoOpen}
          >
            <p className="cormorant-medium text-xl lg:text-3xl  text-primary tracking-[1.98px]">
              Information
            </p>
            <button className="sm:hidden uppercase text-center text-[#666565]">
              <svg
                className={`w-[20px] h-[20px] transform transition-transform duration-500 ${
                  infoOpen ? "rotate-180" : "rotate-0"
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          </div>
          <div className="sm:hidden mb-8">
            {infoOpen && (
              <div className="flex flex-col border-b-2">
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-3 "
                  to="/aboutus"
                >
                  about
                </Link>
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-3 "
                  to="/#coming-soon"
                >
                  careers
                </Link>
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-3 "
                  to="/contact-us"
                >
                  contact us
                </Link>
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-3 "
                  to="/#coming-soon"
                >
                  sustainbility
                </Link>
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-3 "
                  to="/#coming-soon"
                >
                  our store
                </Link>
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-5 "
                  to={"/#coming-soon"}
                >
                  blog
                </Link>
              </div>
            )}
          </div>
          <div className="hidden sm:flex flex-col gap-4">
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/aboutus"
            >
              about
            </Link>
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/#coming-soon"
            >
              careers
            </Link>
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/contact-us"
            >
              contact us
            </Link>
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/#coming-soon"
            >
              sustainbility
            </Link>
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/#coming-soon"
            >
              our store
            </Link>
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              // to="/blog"
              to={"/#coming-soon"}
            >
              blog
            </Link>
          </div>
        </div>

        <div className="order-1 sm:order-2 flex flex-col text-center">
          <p className="cormorant-medium text-xl lg:text-3xl  text-primary mb-9 tracking-[1.32px] md:tracking-[1.98px]">
            Sign Up To Our Newsletter
          </p>
          <input
            type="email"
            name="email"
            onChange={footerformik.handleChange}
            value={footerformik.values.email}
            onBlur={footerformik.handleBlur}
            placeholder="Enter your email"
            className="lato-regular w-[90%] self-center sm:text-[21px] border-b-2 border-gray-300 focus:border-primary outline-none text-center text-[#767676] mb-6"
          />
          {footerformik.touched.email && footerformik.errors.email ? (
            <div className="text-red-500">{footerformik.errors.email}</div>
          ) : null}
          <div
            className="flex justify-center items-center mb-9 max-w-fit mx-auto"
            onClick={footerformik.handleSubmit}
          >
            <button
              href="#"
              className="cormorant-medium text-[14px] sm:text-[16px] bg-transparent border-[1px]  border-primary text-primary px-10 py-[7px] rounded-full inline-block"
            >
              SUBMIT
            </button>
            <img
              src={RightArrow}
              alt="our store"
              className="border-[1px] border-primary rounded-full p-2 text-primary"
            />
          </div>
          <div className=" lato-regular text-[#3F1322] text-lg lg:text-xl text-center mb-8">
            By Signing Up To Our Newsletter, You <br />
            Agree To Receive Marketing Emails From Daga Gems.
          </div>
        </div>

        <div className="order-3 sm:order-3 flex flex-col gap-3">
          <div
            className="flex justify-between items-center"
            onClick={toggleCareOpen}
          >
            <p className="cormorant-medium text-xl lg:text-3xl  text-center text-primary tracking-[1.98px]">
              Customer Care
            </p>
            <button className="sm:hidden uppercase text-center text-[#666565]">
              <svg
                className={`w-[20px] h-[20px] transform transition-transform duration-500 ${
                  careOpen ? "rotate-180" : "rotate-0"
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
          </div>
          <div className="sm:hidden">
            {careOpen && (
              <div className="flex flex-col border-b-2">
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-3 "
                  to="/contact-us"
                >
                  Contact us
                </Link>
                <Link
                  className="lato-regular text-sm uppercase text-[#666565] mb-3 "
                  to="/#coming-soon"
                >
                  Terms & Conditions
                </Link>
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-3 "
                  to="/#coming-soon"
                >
                  Privacy Policy
                </Link>
                <Link
                  className="text-sm lato-regular uppercase text-[#666565] mb-3 "
                  to="/#coming-soon"
                >
                  Return & Refund
                </Link>
              </div>
            )}
          </div>
          <div className="hidden sm:flex flex-col gap-4">
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/contact-us"
            >
              Contact us
            </Link>
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/#coming-soon"
            >
              Terms & Conditions
            </Link>
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/#coming-soon"
            >
              Privacy Policy
            </Link>
            <Link
              className="lato-regular uppercase text-center text-[#666565] sm:text-[12px] md:text-[14px] lg:text-[20px] "
              to="/#coming-soon"
            >
              Return & Refund
            </Link>
          </div>
        </div>
      </div>
      <div className="lg:bg-primary flex flex-col lg:grid lg:grid-cols-[minmax(0,_1fr)_minmax(0,_1fr)_minmax(0,_1fr)] items-center lg:p-4 gap-0 lg:gap-4">
        <div className="order-2 lg:order-none flex flex-row justify-center lg:justify-start px-2 pt-3 lg:pt-0 lg:px-0 text-center sm:text-left w-full bg-primary text-bg_1 text-[16px] tracking-[0.51px] sm:col-start-1 sm:col-end-2">
          <span className="lato-regular text-bg_1 opacity-65 ">
            ©COPYRIGHT DAGA GEMS@{year}
          </span>
        </div>
        <div className="pt-2 lg:pt-0 order-3 bg-primary lg:order-none flex justify-center pb-2 lg:pb-0 items-center sm:col-start-2 sm:col-end-3 text-[15px] w-full">
          <span
            style={{ fontFamily: "Montserrat, sans-serif" }}
            className="text-bg_1 opacity-65 "
          >
            Designed and Developed by
          </span>
          <a
            href="https://plushvie.in/"
            target="_blank"
            className="inline-block"
          >
            <img
              src={plushvie_logo_gold}
              alt="plushvie_logo"
              className="w-24 ms-1 -translate-y-[15%]"
            />
          </a>
        </div>
        <div className="order-1 lg:order-none hidden lg:flex flex-row w-full gap-4 sm:w-auto justify-center sm:justify-end mb-2 lg:mb-0 sm:col-start-3 sm:col-end-4">
          <Link to={INSTAGRAM_LINK} target="_blank">
            <img src={instagram} alt="instagram" className="text-primary" />
          </Link>
          <Link to={FACEBOOK_LINK} target="_blank">
            <img src={facebook} alt="facebook" className="text-primary" />
          </Link>
          <Link to={LINKEDIN_LINK} target="_blank">
            <img src={linkedin_icon} alt="facebook" className="text-primary" />
          </Link>
        </div>
        <div className="mb-4 order-1 lg:order-none flex lg:hidden flex-row w-full gap-4 sm:w-auto justify-center sm:justify-end lg:mb-0 sm:col-start-3 sm:col-end-4">
          <Link to={INSTAGRAM_LINK} target="_blank">
            <img
              src={instagram_primary}
              alt="instagram"
              className="text-primary"
            />
          </Link>
          <Link to={FACEBOOK_LINK} target="_blank">
            <img
              src={facebook_primary}
              alt="facebook"
              className="text-primary"
            />
          </Link>
          <Link to={LINKEDIN_LINK} target="_blank">
            <img
              src={linkedin_icon_primary}
              alt="facebook"
              className="text-primary"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export function isValidEmail(email) {
  const regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}
